import { render, staticRenderFns } from "./OrmBatchingView2.vue?vue&type=template&id=708350cc"
import script from "./OrmBatchingView2.vue?vue&type=script&lang=js"
export * from "./OrmBatchingView2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports